import type { SerializedError } from '@reduxjs/toolkit'
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query'

// A failed make-good generate/regenerate write comes in two shapes the ladder
// words differently. A 409 means the regenerate would change nothing — the
// presented set already equals the recommended one (AI-858 follow-up, nucleus
// Regenerate) — and is NOT terminal: declining a reward and retrying can still
// produce a real diff. Everything else — a 403 (flag/permission skew), a 404,
// a 5xx, or a network error — is transient and keeps the cause-neutral retry
// copy. 409 is the ONLY status the FE branches on; the ladder owns the i18n
// and never renders the raw error body.
export type RegenerateErrorKind = 'conflict' | 'error'

// Map an RTK Query mutation `error` to the kind the ladder renders. Undefined
// error ⇒ undefined (no banner). Only a FetchBaseQueryError carries a numeric
// HTTP `status`; a SerializedError or a network-layer FETCH_ERROR has none and
// falls through to the generic copy.
export const regenerateErrorKind = (
  error: FetchBaseQueryError | SerializedError | undefined
): RegenerateErrorKind | undefined => {
  if (!error) return undefined
  return 'status' in error && error.status === 409 ? 'conflict' : 'error'
}
